const merge = require("deepmerge");

const baseconfig = require("./baseconfig");
const envConfig = require("./environment-config");

const activeConfig = merge(baseconfig, envConfig);

module.exports = activeConfig;
